import EmptyState from '@components/EmptyState'
import React from 'react'

const MaterialNoLearningPath: React.FC = () => (
  <EmptyState
    heading="This course does not include an online Learning Path. Refer to the materials provided to you at the start of the course."
    img="/images/books.svg"
  />
)

export default MaterialNoLearningPath
